import React from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";

const PublicRoute = () => {
  const { businessSlug } = useParams();
  const accessToken = localStorage.getItem("accessToken");
  const branchId = localStorage.getItem("branchId");
  const email = localStorage.getItem("email");
  const branchPOSId = localStorage.getItem("branchPOSId");

  if (!businessSlug) {
    return <Navigate to="/not-found" replace />;
  }

  localStorage.setItem("businessSlug", businessSlug);

  if (accessToken && branchId && email && branchPOSId) {
    return <Navigate to={`/${businessSlug}`} replace />;
  }

  if (accessToken && branchId && email && !branchPOSId) {
    return <Navigate to={`/${businessSlug}/pos-setting`} replace />;
  }

  if (accessToken && email && !branchId) {
    return <Navigate to={`/${businessSlug}/branch-selection`} replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
